export default function contains(array, value) {
	let found = false;
	array.some(element => {
		if (element === value) {
			found = true;
			return true;
		}
		return false;
	});
	return found;
}
